import React, { useContext, useEffect } from "react";
import { AccountContext } from "../Account/AccountContext";
import { Link, NavLink } from "react-router-dom";

export default function Header(props) {

	const { account, logout } = useContext(AccountContext);

	return (
		<nav className="navbar sticky-top navbar-expand-md navbar-light bg-white border-bottom fw-bold">
			<div className="container">
				<span className="navbar-brand order-1 order-md-0 text-body">
					<img src={(window.CONFIG?.basename || "") + "/logo.svg"} alt="Logo" height="50" className="d-inline-block me-4" />
					{t.appName}</span>
				<div className="collapse navbar-collapse" id="mainMenu">
					<ul className="navbar-nav me-auto mb-2 mb-md-0">
						<li className="nav-item"><NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/cards/">{t.cardList}</NavLink></li>
						<li className="nav-item"><NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/requests/">{t.cardRequestList}</NavLink></li>
						{/*{account.isClient && <li className="nav-item"><NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/my-orders">{t.orderMyList}</NavLink></li>}*/}
						{/*{(account.isManager || account.isOrderViewer) && <li className="nav-item"><NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/orders">{t.orderList}</NavLink></li>}*/}
						{/*{account.isProductManager && <li className="nav-item"><NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/products">{t.productList}</NavLink></li>}*/}
						{/*{(account.isAdmin || account.isProductManager) && <li className="nav-item"><NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/teams">{t.teamList}</NavLink></li>}*/}
						{account.isAdmin && <li className="nav-item"><NavLink className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} to="/users">{t.userList}</NavLink></li>}
						{account.isAdmin && <li className="nav-item dropdown">
							<a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">{t.categoryList}</a>
							<ul className="dropdown-menu dropdown-menu-md-end position-absolute">
								<li><Link className="nav-link" to="/categories/department">{t.categoryDepartment}</Link></li>
							</ul>
						</li>}
					</ul>
				</div>
				<ul className="navbar-nav order-0">
					<li className="nav-item dropdown">
						<a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">
							{account.firstName.substring(0, 1)}{account.lastName.substring(0, 1)}
						</a>
						<ul className="dropdown-menu dropdown-menu-md-end position-absolute">
							<li><h6 className="dropdown-header">{account.firstName} {account.lastName}</h6></li>
							<li><a className="dropdown-item" href="#" onClick={(e) => {
								e.preventDefault();
								props.modalProfile.current.show();
							}}>{t.userProfile}</a></li>
							<li><a className="dropdown-item" href="#" onClick={logout}>{t.loginLogout}</a></li>
						</ul>
					</li>
				</ul>
				<button className="navbar-toggler order-2" type="button" data-bs-toggle="collapse" data-bs-target="#mainMenu" aria-controls="mainMenu" aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
			</div>
		</nav>
	)
}